import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OTPLoginBlockData from 'Models/Content/OTPLoginBlockData';
import OTPLogin from './main';

export default class OtpErrorPageBlock extends EpiComponent<OTPLoginBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <OTPLogin iContent={this.props.data} context={this.getContext()} />;
  }
}
